import React from "react";
import "./ProductGrid.css";

// Photos of  Product1

import RawChicken from "../../images/Products/rawchicken.jpg";
import Beef from "../../images/Products/beef.jpg";
import PrimalCuts from "../../images/Products/primalcuts.jpeg";
import Thighs from "../../images/Products/thighs.jpg";
import Wings from "../../images/Products/wings.jpg";
import Drumsticks from "../../images/Products/drumsticks.jpg";
import Boneless from "../../images/Products/boneless.jpeg";
import Breast from "../../images/Products/breast.jpg";
import Paws from "../../images/Products/paws.jpg";
// Photos of  Product2
import Sugar from "../../images/Products/sugar.jpeg";
import Rice from "../../images/Products/rice.jpg";
import Rice2 from "../../images/Products/rice2.jpg";
import Rice3 from "../../images/Products/rice3.jpg";
import Wheat from "../../images/Products/wheat.jpg";
import Wheat2 from "../../images/Products/wheat2.jpg";
import Wheat3 from "../../images/Products/wheat3.jpg";
// Photos of  Product3
import PalmOil from "../../images/Products/palmoil.jpg";
import BroomStick from "../../images/Products/broomstick.jpg";
import Coconut from "../../images/Products/coconut.jpeg";
import BlackPepper from "../../images/Products/blackpepper.jpg";
import Cloves from "../../images/Products/cloves.jpg";
import Pulses from "../../images/Products/pulses.jpg";
import RedBeans from "../../images/Products/redbeans.jpg";
import Dryfruit from "../../images/Products/dryfruit.jpg";
import Walnuts from "../../images/Products/walnuts.jpg";
import Pinenuts from "../../images/Products/pinenut.jpg";
import Almond from "../../images/Products/almond.jpg";

export default function ProductGrid() {
  const products1 = [
    {
      name: "Raw Chicken",
      img: RawChicken,
      grade: "Frozen+Fresh",
    },

    {
      name: "Raw Beef",
      img: Beef,
      grade: "Frozen+Fresh+Boiled",
    },

    {
      name: "Beef Primal Cuts",
      img: PrimalCuts,
      grade: "Frozen+Fresh",
    },
    {
      name: "Chicken Thighs",
      img: Thighs,
      grade: "Frozen+Fresh",
    },
    {
      name: "Chicken Boneless",
      img: Boneless,
      grade: "Frozen+Fresh",
    },
    {
      name: "Chicken Wings",
      img: Wings,
      grade: "Frozen+Fresh",
    },

    {
      name: "Drum Sticks",
      img: Drumsticks,
      grade: "Frozen+Fresh",
    },
    {
      name: "Chicken Breast",
      img: Breast,
      grade: "Frozen+Fresh",
    },
    {
      name: "Chicken Paws",
      img: Paws,
      grade: "Frozen+Fresh",
    },
  ];

  const products2 = [
    {
      name: "Rice Basmati",
      img: Rice,
      grade: "Basmati",
    },
    {
      name: "Rice ",
      img: Rice2,
      grade: "IRRI-6",
    },
    {
      name: "Rice ",
      img: Rice2,
      grade: "IRRI-9",
    },
    {
      name: "Rice ",
      img: Rice3,
      grade: "Single Stream",
    },
    {
      name: "Rice",
      img: Rice3,
      grade: "Double Stream",
    },
    {
      name: "Sugar",
      img: Sugar,
      grade: "ICUMSA-45",
    },
    {
      name: "Wheat",
      img: Wheat,
      grade: "Canadian",
    },
    {
      name: "Wheat",
      img: Wheat2,
      grade: "Ukrainan",
    },
    {
      name: "Wheat",
      img: Wheat3,
      grade: "Pakistani",
    },
  ];

  const products3 = [
    {
      name: "PALM Oil",
      img: PalmOil,
      grade: "Pure",
    },
    {
      name: "Broom Stick",
      img: BroomStick,
      grade: "",
    },
    {
      name: "Coconut",
      img: Coconut,
      grade: "Edible",
    },
    {
      name: "Black pepper ",
      img: BlackPepper,
      grade: "",
    },
    {
      name: "Pulses",
      img: Pulses,
      grade: "All Types",
    },
    {
      name: "Cloves",
      img: Cloves,
      grade: "Premium",
    },
    {
      name: "Dry Fruits",
      img: Dryfruit,
      grade: "Mix",
    },
    {
      name: "Almonds",
      img: Almond,
      grade: "A category",
    },
    {
      name: "Walnuts",
      img: Walnuts,
      grade: "Good Quality",
    },
    {
      name: "Beans",
      img: RedBeans,
      grade: "Red+White",
    },
    {
      name: "Pinenut",
      img: Pinenuts,
      grade: "Roasted+Raw",
    },
  ];

  return (
    <div className="product-grid-section">
      <div className="category">
        <h2>Frozen Meat </h2>
        <div className="product-grid">
          {products1.map((p) => (
            <div className="product-card" key={p.name}>
              <img src={p.img} alt={p.name} />
              <h4>{p.name}</h4>
              <p>{p.grade}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="category">
        <h2>Grains</h2>
        <div className="product-grid">
          {products2.map((p) => (
            <div className="product-card" key={p.name}>
              <img src={p.img} alt={p.name} />
              <h4>{p.name}</h4>
              <p>{p.grade}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="category">
        <h2>Other Specialities</h2>
        <div className="product-grid">
          {products3.map((p) => (
            <div className="product-card" key={p.name}>
              <img src={p.img} alt={p.name} />
              <h4>{p.name}</h4>
              <p>{p.grade}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
